<div
  class="absolute p-5 bg-white right-0 sm:right-4 shadow-[-15px_8px_13px_-9px_rgba(0,0,0,0.1)] flex flex-col w-full sm:w-[470px] z-50 min-h-[calc(100vh_-_248px)] border-l border-slate-400"
  *ngIf="
    selectedReferral != null &&
    ((selectedReferral.marketplaceStatus !== 'Claimed' && selectedReferral.marketplaceStatus !== 'Assigned') || (selectedReferral.email == null && selectedReferral.phone == null))
  "
>
  <div class="text-slate-600 mb-6 flex flex-row justify-between">
    <div class="flex">
      <button (click)="clearReferralSelection()">
        <fa-icon [icon]="faXmark" class="text-slate-500 text-2xl pr-3"></fa-icon>
      </button>
      <div class="flex flex-col text-slate-500 pl-2">
        <div>
          Received {{ UtilityService.isToday(selectedReferral.addDate) ? 'Today' : 'on ' + (selectedReferral.addDate | date: 'shortDate')}}
          at {{ selectedReferral.addDate | date: 'shortTime' }}
        </div>

        @let marketplaceExpirationDate = selectedReferral.marketplaceExpirationDate;
        @if (selectedReferral.marketplaceStatus === 'Available' && marketplaceExpirationDate) {
          @let minutesLeft = getMinutesLeft(marketplaceExpirationDate);
          @if (minutesLeft != null) {
            <div [ngClass]="getMinutesLeftClass(minutesLeft)" class="text-sm mt-1">
                <span class="text-sm">&#x231B;</span>
                {{ getMinutesLeftLabel(minutesLeft) }}
              </div>
          }
        }
      </div>
    </div>

    @if (!authGuard.isCarrier() && !authGuard.isAdmin()) {
      @if (selectedReferral.marketplaceStatus === 'Available' && selectedReferral.opportunityType !== 'WT-CIR') {
        <div class="w-full flex justify-center">
          <div class="flex flex-col items-center">
            <button class="bg-momentum-deep_purple hover:bg-momentum-royal_purple text-white font-bold py-2 px-4 rounded-full min-w-[130px]">
              Claim Now -&nbsp;
              @if (selectedReferral.dynamicPrice != null) {
                ${{ selectedReferral.dynamicPrice }}
              }
            </button>

            @if (hasPriceDecay()) {
              <div class="text-sm text-slate-500 pt-1">
                was <span class="line-through">${{ selectedReferral.discountPrice }}</span>
              </div>
            }
          </div>
        </div>
      }

      @if (selectedReferral.marketplaceStatus === 'Available' && selectedReferral.opportunityType === 'WT-CIR') {
        <button class="bg-blue-800 hover:bg-blue-700 text-white font-bold py-2 px-2 rounded-full min-w-[130px]">
          <fa-icon [icon]="faPhone" class="pr-1"></fa-icon>
          Talk Now
          @if (selectedReferral.discountPrice != null) {
            (${{ selectedReferral.discountPrice }})
          }
        </button>
      }

      @if (selectedReferral.marketplaceStatus === 'Claimed') {
        <button class="bg-slate-100 text-slate-400 py-2 px-4 rounded-full min-w-[130px]" disabled>Claimed</button>
      }

      @if (selectedReferral.marketplaceStatus === 'Settled') {
        <button class="bg-slate-100 text-slate-400 py-2 px-4 rounded-full min-w-[130px]" disabled>Settled</button>
      }

      @if (selectedReferral.marketplaceStatus === 'Incoming') {
        <button class="bg-slate-100 text-slate-400 py-2 px-4 rounded-full min-w-[130px]" disabled>Incoming</button>
      }

      @if (selectedReferral.marketplaceStatus === 'Delivered') {
        <button class="bg-slate-100 text-slate-400 py-2 px-4 rounded-full min-w-[130px]" disabled>Delivered</button>
      }

      @if (selectedReferral.marketplaceStatus === 'Assigned') {
        <button class="bg-slate-100 text-slate-400 py-2 px-4 rounded-full min-w-[130px]" disabled>Assigned</button>
      }
    }

    @if (authGuard.isCarrier() || authGuard.isAdmin()) {
      <div [ngClass]="iconColor[selectedReferral.marketplaceStatus]" class="flex flex-col">
        <div class="flex items-center">
          <fa-icon
            [icon]="icons[selectedReferral.marketplaceStatus]"
            [ngClass]="iconColor[selectedReferral.marketplaceStatus]"
          ></fa-icon>
          <span class="pl-2">
          {{ statusDisplay[selectedReferral.marketplaceStatus] }}

            @if (selectedReferral.marketplaceStatus === 'Available') {
              @if (hasPriceDecay()) {
                (${{ selectedReferral.dynamicPrice }})
              }
              @else {
                  (${{ selectedReferral.discountPrice }})
              }
            }

            @if (
              selectedReferral.soldPrice != null &&
              statusDisplay[selectedReferral.marketplaceStatus] === 'Claimed'
              ) {
              (${{ selectedReferral.soldPrice }})
            }
        </span>
        </div>

        @if (
          selectedReferral.marketplaceStatus === 'Available' && hasPriceDecay()
          ) {
          <div class="text-sm text-slate-500 pl-6">
            was <span class="line-through">${{ selectedReferral.discountPrice }}</span>
          </div>
        }
      </div>
    }
  </div>

  <h3 class="text-lg font-bold">{{ selectedReferral.category === null ? "Direct Call Referral" : selectedReferral.category + " Lines" }}</h3>
  <h1 class="text-3xl font-bold" *ngIf="selectedReferral.industryCode && selectedReferral.industryDescription">
    {{ selectedReferral.industryDescription + " (" + selectedReferral.industryCode + ")" }}
  </h1>
  <h1 class="text-3xl font-bold" *ngIf="!selectedReferral.industryCode || !selectedReferral.industryDescription">{{ selectedReferral.businessLines.join(", ") }}</h1>
  <hr class="mt-4 mb-6 w-10" />
  <div
    *ngIf="selectedReferral.opportunityExternalLinks?.length"
    class="bg-gradient-to-r from-momentum-deep_purple  to-momentum-black bg-no-repeat bg-origin-padding text-center mb-4 px-[5px] py-1.5 rounded-[4px] text-white flex justify-center items-center"
  >
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="14"
      viewBox="0 0 10 14"
      class="mr-1"
    >
      <path
        style="fill: #fff"
        d="M5.98.33c.44,0,.86.17,1.18.49l2.36,2.36c.31.31.49.74.49,1.18v7.64c0,.92-.75,1.67-1.67,1.67H1.67C.75,13.67,0,12.92,0,12V2C0,1.08.75.33,1.67.33h4.31ZM8.33,12.42c.23,0,.42-.19.42-.42v-7.5h-2.08c-.46,0-.83-.37-.83-.83V1.58H1.67c-.23,0-.42.19-.42.42v10c0,.23.19.42.42.42h6.67ZM4.75,10.08c-.12.12-.28.18-.44.18s-.33-.07-.44-.18l-1.39-1.39c-.24-.24-.24-.64,0-.88.24-.24.64-.24.88,0l.95.95,2.34-2.34c.24-.24.64-.24.88,0,.24.24.24.64,0,.88l-2.78,2.78Z"
      /></svg
    >Data-Enriched Referral
  </div>
  <div class="text-slate-600 font-bold mb-2">Referral details</div>
  <ul>
    <li class="details-view-list-item" *ngIf="selectedReferral.industryCode && selectedReferral.industryDescription">
      {{ selectedReferral.industryDescription + " (" + selectedReferral.industryCode + ")" }}
    </li>
    <li
      class="details-view-list-item"
      *ngIf="
        selectedReferral.businessLines.length <= 0 &&
        !selectedReferral.estimatedPremium &&
        !selectedReferral.noOfEmployees &&
        !selectedReferral.yearsInBusiness &&
        !selectedReferral.age &&
        !selectedReferral.gender &&
        !selectedReferral.medicalExam
      "
    >
      TBD
    </li>
    <li class="details-view-list-item" *ngIf="selectedReferral.businessLines.length > 0">{{ selectedReferral.businessLines.join(", ") }}</li>
    <li class="details-view-list-item" *ngIf="selectedReferral.estimatedPremium">{{ selectedReferral.estimatedPremium + " est. premium (estimated by prospect)" }}</li>
    <li class="details-view-list-item" *ngIf="selectedReferral.noOfEmployees">{{ selectedReferral.noOfEmployees + " employees" }}</li>
    <li class="details-view-list-item" *ngIf="selectedReferral.yearsInBusiness">{{ selectedReferral.yearsInBusiness + " years in business" }}</li>
    <li class="details-view-list-item" *ngIf="selectedReferral.age">{{ selectedReferral.age + " years old" }}</li>
    <li class="details-view-list-item" *ngIf="selectedReferral.gender">{{ selectedReferral.gender }}</li>
    <li class="details-view-list-item" *ngIf="selectedReferral.medicalExam">{{ selectedReferral.medicalExam }}</li>
  </ul>

  <div *ngIf="selectedReferral.opportunityExternalLinks?.length">
    <div class="text-slate-600 font-bold mt-6 mb-2">Enriched Referral Data</div>
    <div class="text-slate-600 bg-slate-200 px-4 py-2 inline-block rounded-[4px]">Available after purchase</div>
  </div>

  <div *ngIf="selectedReferral.prospectMessage">
    <div class="text-slate-600 font-bold mt-6 mb-2">Note from referral</div>
    <div class="text-slate-600">{{ selectedReferral.prospectMessage }}</div>
  </div>

  <div class="mt-6 mb-2" *ngIf="selectedReferral.city && selectedReferral.state">
    <div class="text-slate-600 font-bold mb-2">Location</div>
    <div class="text-slate-600">{{ selectedReferral.city + ", " + selectedReferral.state + " " + selectedReferral.postalCode }}</div>
  </div>
</div>

<div
  class="absolute p-5 bg-white right-0 sm:right-4 shadow-[-15px_8px_13px_-9px_rgba(0,0,0,0.1)] flex flex-col w-full sm:w-[470px] z-50 min-h-[calc(100vh_-_248px)] border-l border-slate-400"
  *ngIf="
    selectedReferral != null &&
    (
      selectedReferral.marketplaceStatus == 'Claimed' ||
      selectedReferral.marketplaceStatus == 'Assigned' ||
      authGuard.isAdmin()
    ) &&
    (selectedReferral.email != null || selectedReferral.phone != null)
  "
>
  <div class="text-slate-600 mb-6 flex flex-row justify-between">
    <div class="flex">
      <button (click)="clearReferralSelection()"><fa-icon [icon]="faXmark" class="text-slate-500 text-2xl pr-3"></fa-icon></button>
      <div class="pl-2 flex flex-col">
        <div class="text-slate-500 content-center">
          <span *ngIf="selectedReferral.marketplaceStatus == 'Claimed'"
            >Claimed {{ UtilityService.isToday(selectedReferral.lastModDate) ? "Today" : "on " + (selectedReferral.lastModDate | date: "shortDate") }}
            at
            {{ selectedReferral.lastModDate | date: "shortTime" }}</span
          >
          <span *ngIf="selectedReferral.marketplaceStatus == 'Assigned'"
            >Assigned {{ UtilityService.isToday(selectedReferral.lastModDate) ? "Today" : "on " + (selectedReferral.lastModDate | date: "shortDate") }}
            at
            {{ selectedReferral.lastModDate | date: "shortTime" }}</span
          >
        </div>
        <div class="text-slate-500">{{ selectedReferral.assignedAgency }}</div>
      </div>
    </div>
    <div *ngIf="!authGuard.isCarrier() && !authGuard.isAdmin()">
      <button *ngIf="selectedReferral.marketplaceStatus == 'Assigned'" class="bg-slate-100 text-slate-400 py-2 px-4 rounded-full min-w-[130px]" disabled>Assigned</button>
      <button
        *ngIf="selectedReferral.marketplaceStatus == 'Claimed' && selectedReferral.opportunityType !== 'WT-CIR'"
        class="bg-slate-100 text-slate-400 py-2 px-4 rounded-full min-w-[130px]"
        disabled
      >
        Claimed

        <span *ngIf="selectedReferral.soldPrice != null">(${{ selectedReferral.soldPrice }})</span>
      </button>
      <button *ngIf="selectedReferral.marketplaceStatus == 'Claimed' && selectedReferral.opportunityType == 'WT-CIR'" class="bg-slate-100 text-slate-400 py-2 px-4 rounded-full min-w-[130px]" disabled>
        Transferred

        <span *ngIf="selectedReferral.soldPrice != null">(${{ selectedReferral.soldPrice }})</span>
      </button>
    </div>
    <div *ngIf="authGuard.isCarrier() || authGuard.isAdmin()" [ngClass]="iconColor[selectedReferral.marketplaceStatus]">
      <fa-icon [icon]="icons[selectedReferral.marketplaceStatus]" [ngClass]="iconColor[selectedReferral.marketplaceStatus]"></fa-icon>
      <span class="pl-2">{{ statusDisplay[selectedReferral.marketplaceStatus] }}</span>

      <span *ngIf="selectedReferral.soldPrice != null && statusDisplay[selectedReferral.marketplaceStatus] == 'Claimed'">(${{ selectedReferral.soldPrice }})</span>
      <span *ngIf="selectedReferral.discountPrice != null && statusDisplay[selectedReferral.marketplaceStatus] == 'Available'">(${{ selectedReferral.discountPrice }})</span>
    </div>
  </div>
  <h3 class="text-lg font-bold">{{ selectedReferral.category + " Lines" }}</h3>
  <h1 class="text-3xl font-bold pb-1" *ngIf="selectedReferral.firstName && selectedReferral.lastName">{{ selectedReferral.firstName + " " + selectedReferral.lastName }}</h1>
  <div class="text-slate-600">{{ selectedReferral.phone }}</div>
  <div class="text-slate-600">{{ selectedReferral.email }}</div>
  <hr class="mt-4 mb-6 w-10" />

  <div class="text-slate-600 font-bold mb-2">Referral details</div>
  <ul>
    <li class="details-view-list-item" *ngIf="selectedReferral.industryCode && selectedReferral.industryDescription">
      {{ selectedReferral.industryDescription + " (" + selectedReferral.industryCode + ")" }}
    </li>
    <li class="details-view-list-item">{{ selectedReferral.businessLines.join(", ") }}</li>
    <li class="details-view-list-item" *ngIf="selectedReferral.estimatedPremium">{{ selectedReferral.estimatedPremium + " est. premium (estimated by prospect)" }}</li>
    <li class="details-view-list-item" *ngIf="selectedReferral.noOfEmployees">{{ selectedReferral.noOfEmployees + " employees" }}</li>
    <li class="details-view-list-item" *ngIf="selectedReferral.yearsInBusiness">{{ selectedReferral.yearsInBusiness + " years in business" }}</li>
    <li class="details-view-list-item" *ngIf="selectedReferral.age">{{ selectedReferral.age + " years old" }}</li>
    <li class="details-view-list-item" *ngIf="selectedReferral.gender">{{ selectedReferral.gender }}</li>
    <li class="details-view-list-item" *ngIf="selectedReferral.medicalExam">{{ selectedReferral.medicalExam }}</li>
    <li class="details-view-list-item" *ngIf="selectedReferral.currentlyInsured">Currently Insured</li>
  </ul>

  <div *ngIf="selectedReferral.opportunityExternalLinks?.length">
    <div class="text-slate-600 font-bold mt-6 mb-2">Enriched Referral Data</div>
    <div *ngFor="let link of selectedReferral.opportunityExternalLinks" class="text-slate-600">
      <a [href]="link.url" target="_blank" rel="noopener noreferrer" class="hover:underline">
        {{ link.label }}
      </a>
    </div>
  </div>

  <div *ngIf="selectedReferral.prospectMessage">
    <div class="text-slate-600 font-bold mt-6 mb-2">Note from referral</div>
    <div class="text-slate-600">{{ selectedReferral.prospectMessage }}</div>
  </div>

  <div class="mt-6">
    <div class="text-slate-600 font-bold mb-2">Location</div>
    <div class="text-slate-600" *ngIf="selectedReferral.businessName">{{ selectedReferral.businessName }}</div>
    <div class="text-slate-600" *ngIf="selectedReferral.address1">{{ selectedReferral.address1 }}</div>
    <div class="text-slate-600" *ngIf="selectedReferral.city && selectedReferral.state">{{ selectedReferral.city + ", " + selectedReferral.state + " " + selectedReferral.postalCode }}</div>
    <img
      class="pt-2"
      *ngIf="selectedReferral.showVisualLocation && selectedReferral.searchId"
      [ngSrc]="environment.fulcrumUrl + '/api/v1/street-view/' + selectedReferral.searchId"
      width="300"
      height="200"
    />
  </div>
</div>
